import { useEffect } from 'react'
import { Routes, Route, Navigate, useLocation } from 'react-router-dom'
import Home from './pages/Home'
import Dashboard from './pages/Dashboard'
import KeyRecovery from './pages/KeyRecovery'
import About from './pages/About'
import Security from './pages/Security'
import Terms from './pages/Terms'
import Privacy from './pages/Privacy'
import Help from './pages/Help'
import Features from './pages/Features'
import Feedback from './pages/Feedback'
import MyStory from './pages/MyStory'
import ErrorBoundary from './components/layout/ErrorBoundary'

function ScrollToTop() {
  const { pathname } = useLocation()
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])
  return null
}

export default function App() {
  return (
    <ErrorBoundary>
      <ScrollToTop />
      <Routes>
        {/* Landing page */}
        <Route path="/" element={<Home />} />

        {/* Main dashboard with user ID */}
        <Route path="/u/:userId/*" element={<Dashboard />} />

        {/* Key recovery via email */}
        <Route path="/recover" element={<KeyRecovery />} />

        {/* Content pages */}
        <Route path="/about" element={<About />} />
        <Route path="/security" element={<Security />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/help" element={<Help />} />
        <Route path="/features" element={<Features />} />
        <Route path="/feedback" element={<Feedback />} />
        <Route path="/my-story" element={<MyStory />} />

        {/* Legacy hash-based URL redirect */}
        <Route path="*" element={<LegacyRedirect />} />
      </Routes>
    </ErrorBoundary>
  )
}

// Handle legacy hash-based URLs (#PASSCODE -> /u/PASSCODE)
function LegacyRedirect() {
  // Check if there's a hash in the URL
  if (typeof window !== 'undefined' && window.location.hash) {
    const passcode = window.location.hash.slice(1) // Remove the #
    if (passcode && passcode.length >= 32) {
      return <Navigate to={`/u/${passcode}`} replace />
    }
  }

  return <Navigate to="/" replace />
}
